import React from 'react'
import { BackIcon } from '../../svgIcons/BackIcon'

function BackButton(props: { onClick: () => void; className?: string }) {
    const { onClick, className = '' } = props

    function renderBack() {
        return (
            <div className={`${className} flex items-center mb-2`}>
                <div className='cursor-pointer text-[#0AE8F9] flex flex-row' onClick={onClick}>
                    <BackIcon className='w-5 h-5 mr-2' />
                    <span>Back</span>
                </div>
            </div>
        )
    }

    return renderBack()
}

export default BackButton
